import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const PromoteApi = createApi({
  reducerPath: "PromoteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + `financial/promotion`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  endpoints: (builder) => ({
    promoteUser: builder.mutation({
      query: ({ planId, ownerType } = {}) => {
        const payload = {
          planId,
          ownerType,
        };

        return {
          url: "/promote",
          method: "POST",
          body: payload,
        };
      },
    }),
    getPromotePlan: builder.query({
      query: () => {
        return {
          url: `/plans`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetPromotePlanQuery, usePromoteUserMutation } = PromoteApi;
